$(window).on('load', function () {
    /**
     * メニューボタン（ハンバーガー）の開閉
     */
    $("#menu-btn").on("click", function (e) {
        // 両方にactiveを付与するのはなぜ？？
        $("#nav-menu").toggleClass("active");
        $(this).toggleClass("active");
    });


    /**
     * メニュー内のリンクがクリックされたらナビゲーション閉じる
     */
    $("#nav-menu .menu-group li a").on("click", function (e) {
        $("#nav-menu").removeClass("active");
        $("#menu-btn").removeClass("active");
    });

});